<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="服务类别" prop="serviceType">
                        <Select v-model="info.serviceType"
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in serviceTypeList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="业务类别" prop="busType">
                        <Select v-model="info.busType" 
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in busTypeList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="品牌名称" prop="brandName">
                        <Input v-model="info.brandName" 
                            :readonly="readonly"
                            type="textarea"
                            :rows="3" :maxlength="256">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="品牌参数" prop="brandParam">
                        <quill-editor v-model="info.brandParam"
                            :disabled="loading"
                            ref="myTextEditor"
                            placeholder="编辑品牌参数">
                        </quill-editor>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="相关图片" prop="attachments">
                        <preview-upload v-model="info.attachments"
                            :readonly="readonly" 
                            :format="imgSuffix"
                            multiple :maxNumber="5"
                            @on-delete="onDelete">
                        </preview-upload>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { brandView, brandAdd, brandUpdate } from '@/api/brand-manage'
import { fileDelete } from '@/api/sys-oss'
import PreviewUpload from '_c/preview-upload'
import Dict from '_u/dict'
// 富文本
import quillEditor from '_c/quill-editor'

export default {
    name: 'FormBrand',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: { PreviewUpload, quillEditor},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            loading: false,
            imgSuffix: this.$config.upload.imgSuffix,
            info: {
                id: this.id,
                serviceType: '', // 服务类别
                busType: '', // 业务类别
                brandName: '', // 品牌名称
                brandParam: '', // 品牌参数
                attachments: '', // 相关图片
                ver: '' // 版本号
            },

            dict: {
                serviceType: Dict.NULL,
                busType: Dict.NULL
            },
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can('update') : this.$can('add')
        },

        readonly() {
            return !this.canSave
        },

        ruleValidate() {
            return {
                brandName: [{ required: true, message: '品牌名称必填' }],
                busType: [{ required: true, message: '业务类别必填' }],
                serviceType: [{ required: true, message: '服务类别必填' }],
                attachments: [{ required: true, message: '相关图片必填' }],
            }
        },

        serviceTypeList() {
            return this.dict.serviceType.val()
        },

        busTypeList() {
            return this.dict.busType.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return brandView(this.id)
            } else {
                return Promise.resolve()
            }
        },

        onDelete(file) {
            fileDelete(file.id).then(args => {})
        }
    },

    mounted() {
        var $info = this.$refs.info
        if (!this.canSave) {
            this.$modal.updateBtns([
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        } else {
            this.$modal.updateBtns([
                { type: 'primary', text: '确定', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        }

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([Dict.get(['service_type', 'bus_type']), this.fetch()])
                .then(args => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)

                    if (this.id) {
                        return brandUpdate(formData)
                    } else {
                        return brandAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
